import React, { useEffect } from "react";
import * as msTeams from "@microsoft/teams-js";
import { paths } from "../../routes/path";
import { Text } from "@fluentui/react-components";
import MsTeamsReportsSvg from "../../shared/svg/MsTeamsReportsSvg";
import styles from "./inMeetingAppConfig.module.scss";
import { useTranslation } from "../../shared/translation/Translation";

const InMeetingAppConfig: React.FC = () => {
    const messages = useTranslation();

    useEffect(() => {
        msTeams.pages.config.setConfig({
            contentUrl: `${window.location.origin}${paths.inMeetingApp}`,
            entityId: "in-meeting-app",
        });
        msTeams.pages.config.setValidityState(true);
    }, []);

    return (
        <div className={styles.content}>
            <h2>{messages.inMeetingAppConfig.header}</h2>
            <MsTeamsReportsSvg className={styles.reportsSvg} />
            <Text>{messages.inMeetingAppConfig.info}</Text>
        </div>
    );
};

export default InMeetingAppConfig;
